import RichText from "@components/RichText";
import Section from "@components/Section";
import type { ComponentSectionsCurrentRateSummary } from "@lib/generated/graphql";

interface CurrentRateSummaryProps {
  data: ComponentSectionsCurrentRateSummary;
  staticData?: Record<string, string | null>;
}

const CurrentRateSummary = ({ data, staticData }: CurrentRateSummaryProps) => {
  const content = staticData?.[data.id];
  if (!content) {
    return null;
  }

  return (
    <Section section={data} className="my-m">
      <RichText>{content}</RichText>
    </Section>
  );
};

export default CurrentRateSummary;
